import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { MonitoreoConfiguracionContentRender } from "./MonitoreoConfiguracionContentRender";

/** Modal full-screen de configuración del módulo de monitoreo de la finca
 *  activa. Se abre desde el ítem "Configuración" del grupo Monitoreo del menú,
 *  igual que el de ganadería. No lleva botón guardar: cada sección persiste
 *  sola (guardado automático), así que la barra solo trae el botón de volver. */
export class MonitoreoConfiguracionModal extends BaseFullScreenModalRender {
  /** Id del elemento raíz auto-montado en `body`. */
  protected readonly elementId = "monitoreoConfiguracionModal";

  /** Título de la barra superior. */
  protected get title(): string {
    return "Configuración de monitoreo";
  }

  /** Subtítulo de la barra: nombre de la finca activa. */
  protected get subtitle(): string {
    return serviceProvider.getFincaSelectedService().getRequired().nombreFinca;
  }

  /** Cuerpo del modal con las secciones de configuración. */
  protected getContent(): IConnectRender {
    return new MonitoreoConfiguracionContentRender();
  }
}
